class LeobelaFaq extends HTMLElement {
  connectedCallback() {
    this.items = [...this.querySelectorAll('[data-leobela-faq-item]')];
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    this.items.forEach((item) => {
      const trigger = item.querySelector('.leobela-faq__trigger');
      trigger?.addEventListener('click', () => this.toggle(item));
    });
  }

  toggle(item) {
    const trigger = item.querySelector('.leobela-faq__trigger');

    if (trigger.getAttribute('aria-expanded') === 'true') {
      this.close(item);
      return;
    }

    this.items.forEach((otherItem) => {
      if (otherItem !== item) this.close(otherItem);
    });

    this.open(item);
  }

  open(item) {
    const trigger = item.querySelector('.leobela-faq__trigger');
    const panel = item.querySelector('.leobela-faq__answer');

    this.cancelAnimation(panel);
    trigger.setAttribute('aria-expanded', 'true');
    panel.hidden = false;

    if (this.reducedMotion.matches) return;

    panel.style.height = '0px';
    panel.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      panel.style.height = `${panel.scrollHeight}px`;
    });

    this.finishAnimation(panel, () => {
      panel.style.height = '';
      panel.style.overflow = '';
    });
  }

  close(item) {
    const trigger = item.querySelector('.leobela-faq__trigger');
    const panel = item.querySelector('.leobela-faq__answer');

    if (panel.hidden) return;

    this.cancelAnimation(panel);
    trigger.setAttribute('aria-expanded', 'false');

    if (this.reducedMotion.matches) {
      panel.hidden = true;
      return;
    }

    panel.style.height = `${panel.getBoundingClientRect().height}px`;
    panel.style.overflow = 'hidden';

    requestAnimationFrame(() => {
      panel.style.height = '0px';
    });

    this.finishAnimation(panel, () => {
      panel.hidden = true;
      panel.style.height = '';
      panel.style.overflow = '';
    });
  }

  finishAnimation(panel, callback) {
    const onTransitionEnd = (event) => {
      if (event.propertyName !== 'height') return;
      panel.removeEventListener('transitionend', onTransitionEnd);
      panel._leobelaFaqTransitionEnd = null;
      callback();
    };

    panel._leobelaFaqTransitionEnd = onTransitionEnd;
    panel.addEventListener('transitionend', onTransitionEnd);
  }

  cancelAnimation(panel) {
    if (!panel._leobelaFaqTransitionEnd) return;

    panel.removeEventListener('transitionend', panel._leobelaFaqTransitionEnd);
    panel._leobelaFaqTransitionEnd = null;
  }
}

if (!customElements.get('leobela-faq')) {
  customElements.define('leobela-faq', LeobelaFaq);
}
